import React from "react";

import { ApiError } from "@/shared/api/errors";

/* What went wrong, next to where it went wrong. A code the dialog expects gets
   the dialog's own words, and a validation failure says what was wrong with the
   field. Anything else is the server's message with its request id — the
   handle that makes a report findable. */
export function FormError({ error, words = {} }: { error: unknown; words?: Partial<Record<number, string>> }) {
  if (!error) return null;
  const api = error instanceof ApiError ? error : null;
  const known = (api?.code != null ? words[api.code] : undefined) ?? api?.details?.[0]?.issue;
  return (
    <p role="alert" className="m-0 text-[12.5px] leading-[1.5] text-[var(--danger)]">
      {known ?? (error instanceof Error ? error.message : "Something went wrong.")}
      {!known && api?.request_id && <span className="font-mono text-[var(--text-quaternary)]"> · ref {api.request_id}</span>}
    </p>
  );
}
